var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1EFCFCEC-AE28-4854-877E-0D82428B5D29") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insights-Copy-2",
    transform: "translate(-333.000000, -29.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.09938,35.000089 L344.771938,30.3272908 C345.076021,30.0233447 345.076021,29.5319058 344.771938,29.2279596 C344.467999,28.9240135 343.97657,28.9240135 343.67263,29.2279596 L338.999929,33.9007578 L334.32737,29.2279596 C334.023288,28.9240135 333.532001,28.9240135 333.228062,29.2279596 C332.923979,29.5319058 332.923979,30.0233447 333.228062,30.3272908 L337.90062,35.000089 L333.228062,39.6728871 C332.923979,39.9768333 332.923979,40.4682722 333.228062,40.7722184 C333.379533,40.9238355 333.578696,41 333.777716,41 C333.976736,41 334.175756,40.9238355 334.32737,40.7722184 L338.999929,36.0994202 L343.67263,40.7722184 C343.824244,40.9238355 344.023264,41 344.222284,41 C344.421304,41 344.620324,40.9238355 344.771938,40.7722184 C345.076021,40.4682722 345.076021,39.9768333 344.771938,39.6728871 L340.09938,35.000089 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.206c11ffdaa6e7a333a74dfdb83a7ab5.svg";
export { ForwardRef as ReactComponent };